import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { List } from 'semantic-ui-react';

// this component support showing text as list of text delimited by /r/n (NewLine)
const TextList = ({ text }) => {
    const delimiter = useMemo(() => /\r?\n|\r|\n/g, [])

    const textList = useMemo(() => text?.split(delimiter), [text])

    if (!text) {
        return null
    }

    return (
        <List bulleted>
            {textList.map((t, index) => (
                <List.Item key={index}>
                    <span>
                        {t}
                    </span>
                </List.Item>
            ))}
        </List>
    )
}

TextList.propTypes = {
    text: PropTypes.string
};

export default TextList;
